import { getFrontLogger } from 'utils/loggers/FrontLogger';

type PerformanceResourceEntry = PerformanceEntry & {
  deliveryType: 'cache' | 'navigational-prefetch' | '';
  responseStatus: number;
  decodedBodySize: number;
  initiatorType: string;
  contentType: string;
};

export function tryToLogContentSecurityViolationsForDebuggingPurpose() {
  if (typeof window.ReportingObserver === 'function') {
    // supported on Chrome only for now
    const observer = new ReportingObserver(
      reports => {
        reports.forEach(({ type, url, body }) => {
          if (type === 'csp-violation') {
            const violationDetails = (body as any)?.toJSON();
            if (violationDetails?.disposition === 'enforce') {
              getFrontLogger().warn(
                'Browser report a CSP violation for {reportUrl}: {sourceFile}:{lineNumber} {effectiveDirective}',
                url,
                violationDetails?.sourceFile,
                violationDetails?.lineNumber,
                violationDetails?.effectiveDirective,
              );
            }
          }
          if (type === 'deprecation') {
            const violationDetails = (body as any)?.toJSON();
            getFrontLogger().warn(
              'Browser report a deprecated call for {reportUrl}: {sourceFile}:{lineNumber} {id}',
              url,
              violationDetails?.sourceFile,
              violationDetails?.lineNumber,
              violationDetails?.id,
            );
          }
        });
      },
      { buffered: true },
    );
    observer.observe();
  }

  if (typeof window.PerformanceObserver === 'function') {
    const observer = new PerformanceObserver(entries => {
      entries.getEntries().forEach(e => {
        const entry = e as PerformanceResourceEntry;
        if (entry.name.endsWith('.js') || entry.name.endsWith('.css')) {
          const json = entry.toJSON();
          if (entry.responseStatus < 200 || entry.responseStatus > 299) {
            getFrontLogger().warn(
              'Resource {name} was not downloaded : status={responseStatus}, initiator={initiatorType}, duration={duration} => {json}:',
              entry.name,
              entry.responseStatus,
              entry.initiatorType,
              entry.duration,
              JSON.stringify(json),
            );
          }
        }
      });
    });

    observer.observe({ type: 'resource', buffered: true });
  }
}
